// src/core/PlayerIdentity.js

const STORAGE_KEY = 'altlab_player_name';

class PlayerIdentity {
    static getName() {
        return localStorage.getItem(STORAGE_KEY);
    }

    static setName(name) {
        const clean = name.trim().substring(0, 20);
        if (clean) {
            localStorage.setItem(STORAGE_KEY, clean);
        }
        return clean;
    }

    static hasName() {
        return !!localStorage.getItem(STORAGE_KEY);
    }

    /**
     * Shows a prompt overlay to get the player's name.
     * Returns a promise that resolves with the name.
     */
    static prompt() {
        return new Promise((resolve) => {
            const existing = PlayerIdentity.getName();
            if (existing) {
                resolve(existing);
                return;
            }

            const overlay = document.createElement('div');
            overlay.className = 'player-name-overlay';
            overlay.innerHTML = `
                <div class="player-name-dialog">
                    <h2>What's your name?</h2>
                    <p>For the leaderboard</p>
                    <input type="text" class="player-name-input" placeholder="Enter name..." maxlength="20" autofocus />
                    <button class="player-name-submit ui-element">Let's go</button>
                </div>
            `;

            document.body.appendChild(overlay);

            const input = overlay.querySelector('.player-name-input');
            const btn = overlay.querySelector('.player-name-submit');

            const submit = () => {
                const name = PlayerIdentity.setName(input.value || 'Anonymous');
                overlay.remove();
                resolve(name);
            };

            btn.addEventListener('click', submit);
            input.addEventListener('keydown', (e) => {
                if (e.key === 'Enter') submit();
            });

            // Focus after a tick (for mobile)
            setTimeout(() => input.focus(), 100);
        });
    }
}

export default PlayerIdentity;
